import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const LlmServiceList = React.lazy(() => import('../components/LlmServiceList'));

function LlmServiceListView(props: Object) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <LlmServiceList {...props} />
    </Suspense>
  );
}

export default LlmServiceListView;
